import React from 'react'

const TakeClass = () => {
    return (
        <>
            <div className="take-class">
                <p className="text">
                    Take our classes and <br />
                    boost your career
                </p>
                <a href="#" className="btn">Get started</a>
            </div>
        </>
    )
}

export default TakeClass
